import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  ArticleLocationRow,
  ReservedMovementRelation,
} from "./TransferLocationTable/types";

type Props = {
  open: boolean;
  row: ArticleLocationRow | null;
  reservedQuantity: number;
  relations: ReservedMovementRelation[];
  loading: boolean;
  onClose: () => void;
};

export default function TransferReservedMovementsDialog({
  open,
  row,
  reservedQuantity,
  relations,
  loading,
  onClose,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Movimientos relacionados a mercaderia reservada</DialogTitle>
      <DialogContent>
        <Box pt={1} display="flex" flexDirection="column" gap={2}>
          <Typography variant="subtitle2">
            {row?.article?.code} - {row?.article?.description}
          </Typography>

          <Typography variant="body2">Un. Reserv.: {reservedQuantity}</Typography>

          {loading ? (
            <Box py={3} display="flex" justifyContent="center">
              <CircularProgress size={24} />
            </Box>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Movimiento</TableCell>
                  <TableCell>Cliente Asociado</TableCell>
                  <TableCell align="right">Cantidad</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {relations.length ? (
                  relations.map((item) => (
                    <TableRow
                      key={`${item.movement_id}-${item.associated_client ?? ""}`}
                    >
                      <TableCell>#{item.movement_id}</TableCell>
                      <TableCell>{item.associated_client || "-"}</TableCell>
                      <TableCell align="right">{item.amount}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3}>
                      {reservedQuantity > 0
                        ? "No hay movimientos relacionados para esta mercaderia reservada."
                        : "Esta mercaderia no posee unidades reservadas, por lo que no hay movimientos relacionados."}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
